import { createAction } from 'redux-actions'
import { INIT } from './types'

export const init = createAction(INIT)
